import axios from 'axios'
import store from '../store'
import qs from 'qs'
import { baseUrl } from '../../config/index'
// rsa加密与验签
import encrypt from '@/common/encryptModule';
// axios.defaults.baseURL = 'http://xxsc.sendinfo.com.cn'
axios.defaults.timeout = 20000
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'

// request 拦截器
axios.interceptors.request.use(
  config => {
    //用于loading处理
    config.headers['access-token'] = localStorage.getItem("xjsc_login_access_token_2019_3_7");
    if (typeof config.params !== 'undefined') config.params.merchantInfoId = localStorage.getItem('m_id');
    config.url = process.env.NODE_ENV == 'production' ? baseUrl + config.url : config.url;
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// response拦截
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    // console.log(error)
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = '请求错误'
          let isLogin = true
          isLogin = error.config.params&&error.config.params.isLogin?false:true
          if (isLogin) {
            store.commit('removeTokenInfo')
            store.dispatch('updateLogin', false)
            store.dispatch('updateLoginShow', true)
          }
          break
        case 403:
          error.message = '拒绝访问'
          break
        case 404:
          error.message = `请求地址出错: ${error.response.config.url}`
          break
        case 408:
          error.message = '请求超时'
          break
        case 500:
          error.message = '服务器内部错误'
          break
        case 501:
          error.message = '服务未实现'
          break
        case 502:
          error.message = '网关错误'
          break
        case 503:
          error.message = '服务不可用'
          break
        case 504:
          error.message = '网关超时'
          break
        case 505:
          error.message = 'HTTP版本不受支持'
          break
        default:
      }
    }
    return Promise.reject(error)
  }
)

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function apiGet(url, params = {}) {
  axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params,
    })
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        reject(err)
        // if (err.message === 'Network Error') {
        //     // console.log(0)
        //     // window.location.href="https://testwww.lotsmall.cn/admin/storeMerchant/login#"
        //   } else {
        //     reject(err)
        //   }
      })
  })
}

/**
 * 封装post方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function apiPost(url, params = {}) {
  const { sk, sign } = encrypt.setSign(params, false);
  axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
  axios.defaults.headers.post['sk'] = sk
  axios.defaults.headers.post['sign'] = sign
  return new Promise((resolve, reject) => {
    params = qs.stringify(params)
    axios.post(url, params)
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        console.log(err)
        // if (err.message === 'Network Error') {
        //     // console.log(0)
        //     window.location.href="https://testwww.lotsmall.cn/admin/storeMerchant/login#"
        //   } else {
        //     reject(err)
        //   }
      })
  })
}

/**
 * 封装post方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function apiPostJson(url, params = {}) {
  axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}
/**
 * 封装DELETE方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function apiDelete(url, params = {}) {
  axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
  return new Promise((resolve, reject) => {
    axios.delete(url, params)
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}



// WEBPACK FOOTER //
// ./src/fetch/api.js